import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiRequestService {
  APIURL:string = "https://staging.protoexpress.com/sierra-app/";
  encryptURL:string = "https://smpbackendstaging.app.protoexpress.com/";
  encryptedData:any = {};

  constructor(private http: HttpClient,
              ) { 
  }

  generateAccessToken(){
    var headers = new HttpHeaders().set("Authorization", "Basic c2llcnJhLWNsaWVudDpzaWVycmEtc2VjcmV0" )
                      .set("Content-Type", "application/x-www-form-urlencoded" )
                      .set("Accept", "application/json" )
                      .set("Access-Control-Allow-Origin", "*" )
                      .set("Access-Control-Allow-Methods", "GET" )
                      .set("Access-Control-Allow-Methods", "PUT" )
                      .set("Access-Control-Allow-Methods", "POST" )
                      .set("Access-Control-Allow-Methods", "DELETE" )
                      .set("Access-Control-Allow-Methods", "OPTIONS" )
                      .set("Access-Control-Allow-Methods", "POST" )
                      .set("Access-Control-Allow-Headers", "X-Requested-With" );

      const body = new HttpParams()
        .set('username', "KiCAD")
        .set('password', "53A97D2E6318761A7ACB5DC09AA03B0E")
        .set('grant_type', 'password');

      return this.http.post<any>( this.APIURL + "/oauth/token", body, {headers})
  }

  formSubmit(paramObj:any, fileData:any, token:any){
    // var dataObj = ;
    let headers = new HttpHeaders().set("Authorization", "bearer "+token );
    let body = new FormData();
    for(var i=0; i<fileData.length; i++){
      body.append('customerFile',fileData[i].file);
    }
    body.append('layoutDesignForm', JSON.stringify(paramObj));
    // userID: this.userId,
    var paramsObj = { userID: this.encryptedData.userData.userId}
    // var paramsObj = { userID:"414eff15-2b22-35f1-a9c1-0bf10b8a1977"}
               
    var options = { headers: headers , params: paramsObj};
    
    return this.http.post<any>( this.APIURL + "layoutDesignRequest" ,body, options)
  }

  getUserData(encData : any){
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    return this.http.get<any>(this.encryptURL + 'smp/drf/decryption?data='+this.encryptedData['encrypt'], {headers: headers})
  }
}
